import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import NodeListHeader from './NodeListHeader';
import NodeList from './NodeList';
import { sortNode } from '~app/actions/nodeList';

const NodeListPanel = ({nodeList, sortNode}) => (
  <div className="NodeListPanel">
    <NodeListHeader title={nodeList.header.title}
                    description={nodeList.header.description}/>
    <NodeList list={nodeList} 
              lockAxis="y" 
              lockToContainerEdges={true}
              pressDelay={200} 
              onSortEnd = {({oldIndex, newIndex}) => sortNode(oldIndex, newIndex)}/>
  </div>
);

NodeListPanel.propTypes = {
  nodeList: PropTypes.object,
  sortNode: PropTypes.func,
};

const mapStateToProps = (state) => ({
  nodeList: state.nodeList.present,
});

const mapDispatchToProps = {
  sortNode,
};

export { NodeListPanel };
export default connect(mapStateToProps, mapDispatchToProps)(NodeListPanel);



// WEBPACK FOOTER //
// ./src/pages/Main/NodeList/NodeListPanel.js